import React, { useState, useEffect } from "react";
import { Row, Col, Typography } from "antd";
import styled from "styled-components";
import Slider from "react-slick";
import { Card, Rate } from "antd";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import hotelimge from "../image/Hotel.webp";
import hotelimge2 from "../image/Hotel2.webp";
import hotelimge3 from "../image/Hotelsec2img.png";
import Realimge from "../image/Real.webp";
import Realimge2 from "../image/Real2.webp";
import Realimge3 from "../image/Real3.webp";
import Exportimportimge from "../image/Export-import.webp";
import Exportimportimge2 from "../image/Export-import 2.webp";
import Exportimportimge3 from "../image/Export-import 3.webp";
import Textileimge from "../image/Textile.webp";
import Textileimge2 from "../image/Textile 2.webp";
import Textileimge3 from "../image/Textile 3.webp";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const Container = styled.div`
  margin-top: 20px;
`;

const CategoriesText = styled.span`
  font-size: 32px;
  font-weight: normal;
  @media (max-width: 768px) {
    text-align: center;
    display: block;
  }
`;

// const MenuContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   margin-top: 20px;
//   margin-bottom: 20px;
// `;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; /* Center horizontally */
  text-align: center; /* Ensure text aligns in center */
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const CategoryTitle = styled(Title)`
  && {
    font-size: 16px;
    color: #00a870;
    margin: 0;
  }
`;

const MenuItem = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  color: black;
  cursor: pointer;
  color: ${(props) => (props.active ? "#00a76f" : "black")};

  &:hover {
    color: #00a76f;
  }
`;

const CheckMore = styled(Text)`
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
`;

const SliderContainer = styled.div`
  .slick-prev,
  .slick-next {
    font-size: 24px;
    color: #00a76f;
    z-index: 10;
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-prev::before,
  .slick-next::before {
    font-size: 30px;
    color: #00a76f;
  }
`;

const ProductCard = styled(Card)`
  width: 285px;
  height: 0px;
  text-align: start;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  .product-image {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
    border-radius: 12px;
  }
  .containstyle {
    font-size: 15px;
    font-family: math;
  }
  .price {
    font-size: 20px;
    font-weight: bold;
    color: #00a76f;
  }

  .old-price {
    text-decoration: line-through;
    color: gray;
    margin-left: 5px;
  }
`;

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  nextArrow: <DoubleRightOutlined />,
  prevArrow: <DoubleLeftOutlined />,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

// Sample Product Data
const products = [
  {
    id: 1,
    name: "🍽️ Our Restaurant – Coming Soon",
    category: "Hotel Industry",
    slogan: "",
    Containt: (
      <>
        <ul>
          <li>
          We’re working on launching a modern, multi-cuisine restaurant that offers
          </li>
          <li>
            Fresh and flavorful dishes from Indian and international cuisines
          </li>
        </ul>
      </>
    ),
    // "Modern hospitality trends, personalized services, and AI-driven automation improve customer satisfaction.",
    image: hotelimge,
    rating: 5,
  },
  {
    id: 2,
    name: "🍽️ What We Offer",
    category: "Hotel Industry",
    Containt: (
      <>
        <ul>
          <li>A family-friendly dining experience with premium service</li>
          <li>Takeaway and delivery options for your convenience</li>
          <li>Hygienic kitchen and warm, aesthetic interiors</li>
        </ul>
      </>
    ),
    // "Luxury accommodations, smart hotel technologies, and diversified services increase profitability.",
    image: hotelimge2,
    rating: 5,
  },
  {
    id: 3,
    name: "🍽️ Sustainability & Innovation",
    category: "Hotel Industry",
    Containt: (
      <>
        <ul>
          <li>
            Eco-friendly hotels, smart energy management, and green
            certifications attract eco-conscious travelers.
          </li>
        </ul>
      </>
    ),
    image: hotelimge3,
    rating: 5,
  },
  {
    id: 4,
    name: " 🌍 Import & Export Services ",
    category: "Export-Import Industry",
    slogan: "Your Gateway to Global Trade",
    Containt:
      "We are building a robust import-export network to trade high-quality goods between India and international markets.",
    image: Exportimportimge,
    rating: 3,
  },
  {
    id: 5,
    name: "📦 Our Focus Areas:",
    category: "Export-Import Industry",
    Containt: (
      <>
        <ul>
          <li>Export of Indian textiles, food items, and home products</li>
          <li>Import of raw materials, electronics, and unique global goods</li>
        </ul>
      </>
    ),
    // "• Export of Indian textiles, food items, and home products •	Import of raw materials, electronics, and unique global goods ",
    image: Exportimportimge2,
    rating: 3,
  },
  {
    id: 6,
    name: "🌍📦 Our Focus Areas:",
    category: "Export-Import Industry",
    Containt: (
      <>
        <ul>
          <li>End-to-end documentation &amp; logistics</li>
          <li>Partner network in multiple countries</li>
        </ul>
      </>
    ),
    // "•	End-to-end documentation & logistics •	Partner network in multiple countries",
    image: Exportimportimge3,
    rating: 3,
  },
  {
    id: 7,
    name: "👕 Textile & Garment Trade",
    category: "Textile Industry",
    Containt:
      "We are building a textile and garments business focused on sourcing and supplying premium fabrics and ready-made clothes for local and global markets.",
    image: Textileimge,
    rating: 1,
  },
  {
    id: 8,
    name: "🧵 What We Offer:",
    category: "Textile Industry",
    slogan: "Fabric for the Future",
    Containt: (
      <>
        <ul>
          <li>
            Wholesale supply of fabrics (cotton, silk, synthetics, blends)
          </li>
          <li>Readymade garments for men, women, and kids</li>
        </ul>
      </>
    ),
    // "• Wholesale supply of fabrics (cotton, silk, synthetics, blends) •	Readymade garments for men, women, and kids ",
    image: Textileimge2,
    rating: 1,
  },
  {
    id: 9,
    name: "👕 What We Offer:",
    category: "Textile Industry",
    Containt: (
      <>
        <ul>
          <li>B2B and B2C orders</li>
          <li>International shipping &amp; custom orders</li>
        </ul>
      </>
    ),
    //  "• B2B and B2C orders • International shipping & custom orders",
    image: Textileimge3,
    rating: 1,
  },
  {
    id: 10,
    name: "🏠 Real Estate Solutions",
    category: "Real Estate Industry",
    slogan: "Invest Smart. Build Bold.",
    Containt:
      "Our real estate division is aimed at helping people and businesses find the right spaces — from plots and houses to commercial properties.",
    image: Realimge,
    rating: 1,
  },
  {
    id: 11,
    name: "🏠 Our Future Plans",
    category: "Real Estate Industry",
    Containt: (
      <>
        <ul>
          <li>Residential layouts in growing areas</li>
          <li>Commercial complexes for rent/sale</li>
        </ul>
      </>
    ),
    // "•	Land acquisition & development •	Property investment guidance",
    image: Realimge2,
    rating: 1,
  },
  {
    id: 12,
    name: "🏗️ Our Future Plans:",
    category: "Real Estate Industry",
    Containt: (
      <>
        <ul>
          <li>Land acquisition &amp; development</li>
          <li>Property investment guidance</li>
        </ul>
      </>
    ),
    // "•	Residential layouts in growing areas •	Commercial complexes for rent/sale ",
    image: Realimge3,
    rating: 1,
  },
];

const categories = [
  "Hotel Industry",
  "Textile Industry",
  "Real Estate Industry",
  "Export-Import Industry",
];

const Section2 = () => {
  const [selectedCategory, setSelectedCategory] = useState("Hotel Industry");

  // Updated filtering logic
  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((product) => product.category === selectedCategory);

  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);
  const Functionscrooll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <Container>
      <Row>
        <Col xs={24} md={3}></Col>
        <Col xs={24} md={18}>
          <Col xs={24} md={24}>
            <CategoriesText>Services</CategoriesText>
          </Col>
          <Row>
            <Col xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 1.0 }}
                className="motion-div"
                data-aos="fade-up"
              >
                <MenuContainer>
                  {/* <CategoryTitle level={5}>Sunglasses</CategoryTitle> */}
                  {categories.map((category) => (
                    <MenuItem
                      key={category}
                      active={selectedCategory === category}
                      onClick={() => setSelectedCategory(category)}
                    >
                      {category}
                    </MenuItem>
                  ))}
                  {/* <CheckMore onClick={() => setSelectedCategory("All")}>
                    CHECK MORE
                  </CheckMore> */}
                  <CheckMore>
                    <Link
                      to="/services"
                      onClick={Functionscrooll}
                      style={{ color: "black" }}
                    >
                      {" "}
                      CHECK MORE
                    </Link>
                  </CheckMore>
                </MenuContainer>
              </motion.div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={19} xl={19} xxl={19}>
              <motion.div
                // whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 1.0 }}
                className="motion-div"
                data-aos="fade-up"
              >
                <SliderContainer>
                  <Slider {...settings}>
                    {filteredProducts.map((product) => (
                      <ProductCard key={product.id}>
                        <img
                          className="product-image"
                          src={product.image}
                          alt={product.name}
                        />
                        <h3 style={{ textAlign: "center" }}>{product.name}</h3>
                        {/* <b>{product.slogan}</b> */}
                        <p className="containstyle">
                          {product.slogan} {product.Containt}
                        </p>
                        <div style={{ textAlign: "center" }}>
                          <Rate disabled defaultValue={product.rating} />
                        </div>

                        {/* <p>FRAME SIZE: {product.frameSize}</p> */}
                      </ProductCard>
                    ))}
                  </Slider>
                </SliderContainer>
              </motion.div>
            </Col>
          </Row>
        </Col>
        <Col xs={24} md={3}></Col>
      </Row>
    </Container>
  );
};

export default Section2;
